<script>
import Hours from '@/components/Hours.vue'

export default {
    name: 'Footer',
    components: { Hours },
    methods: {
        scrollTo(id) {
            const el = document.getElementById(id)
            if (el) el.scrollIntoView({ behavior: 'smooth' })
        },
    },
}
</script>

<template>
    <footer class="site-footer">
        <div class="footer-container">
            <b-row class="footer-inner">
                <b-col cols="12" lg="5" class="footer-brand mb-4 mb-lg-0">
                    <img src="@/assets/images/shiftos-logo-simplified-white-web.png" alt="Sim Racing Support" class="nav-logo-img" height="30" />
                    <p>&nbsp;</p>
                    <p class="footer-tagline">Expert sim racing support from people who race. ShiftOS customers, franchisees, and individual racers — we've got you covered.</p>
                    <p class="footer-sub">A Particle Storm product</p>
                </b-col>
                <b-col cols="12" sm="4" lg class="footer-col mb-4 mb-sm-0">
                    <h4>Services</h4>
                    <ul>
                        <li><b-button @click="scrollTo('services')">ShiftOS Support</b-button></li>
                        <li><b-button @click="scrollTo('services')">Franchise Support</b-button></li>
                        <li><b-button @click="scrollTo('services')">Sim Tech Support</b-button></li>
                        <li><b-button @click="scrollTo('supported')">What We Support</b-button></li>
                    </ul>
                </b-col>
                <b-col cols="12" sm="4" lg class="footer-col mb-4 mb-sm-0">
                    <h4>ShiftOS</h4>
                    <ul>
                        <li><b-button tag="a" href="https://shiftos.app" target="_blank" rel="noopener">shiftos.app</b-button></li>
                        <li><b-button tag="a" href="https://shiftos.app/#operate" target="_blank" rel="noopener">Operate</b-button></li>
                        <li><b-button tag="a" href="https://shiftos.app/#launch" target="_blank" rel="noopener">Launch</b-button></li>
                        <li><b-button tag="a" href="https://shiftos.app/#engage" target="_blank" rel="noopener">Engage</b-button></li>
                    </ul>
                </b-col>
                <b-col cols="12" sm="4" lg class="footer-col">
                    <h4>Get Help</h4>
                    <ul>
                        <li><b-button @click="scrollTo('ticket')">Submit a Ticket</b-button></li>
                        <li><b-button tag="a" href="https://shiftos.app/privacy" target="_blank" rel="noopener">Privacy Policy</b-button></li>
                        <li><b-button tag="a" href="https://shiftos.app/terms" target="_blank" rel="noopener">Terms of Service</b-button></li>
                    </ul>
                </b-col>
            </b-row>
            <div class="footer-bottom">
                <span>© 2026 Particle Storm LLC · All rights reserved</span>
                <span>Support hours: <hours /></span>
            </div>
        </div>
    </footer>
</template>

<style scoped>
.site-footer {
    background: #0f0f0f;
    border-top: 1px solid #1f1f1f;
    padding: 56px 0 32px;
}

.footer-container {
    max-width: 1140px;
    margin: 0 auto;
    padding: 0 28px;
}

.footer-inner {
    margin-bottom: 40px;
}

.footer-logo {
    height: 36px;
    width: auto;
    display: block;
    margin-bottom: 14px;
    filter: brightness(0) invert(1);
    opacity: 0.8;
}

.footer-tagline {
    font-size: 13px;
    color: #6b7280;
    line-height: 1.6;
    max-width: 280px;
    margin-bottom: 10px;
    font-family: 'Inter', system-ui, sans-serif;
}

.footer-sub {
    font-size: 12px;
    color: #4b5563;
    font-family: 'Inter', system-ui, sans-serif;
    margin: 0;
}

.footer-col h4 {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #6b7280;
    margin-bottom: 16px;
    font-family: 'Inter', system-ui, sans-serif;
}

.footer-col ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.footer-col li a,
.footer-col li button {
    font-size: 13px;
    color: #4b5563;
    transition: color 0.15s;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    font-family: 'Inter', system-ui, sans-serif;
    text-align: left;
    text-decoration: none;
}

.footer-col li a:hover,
.footer-col li button:hover {
    color: #9ca3af;
}

.footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 24px;
    border-top: 1px solid #1f1f1f;
    font-size: 12px;
    color: #4b5563;
    font-family: 'Inter', system-ui, sans-serif;
}

@media (max-width: 560px) {
    .footer-bottom {
        flex-direction: column;
        gap: 8px;
        text-align: center;
    }
}
</style>
